export enum countTypes {
  FETCH_COUNT_REQUEST = "FETCH_COUNT_REQUEST",
  FETCH_COUNT_SUCCESS = "FETCH_COUNT_SUCCESS",
  FETCH_COUNT_FAILURE = "FETCH_COUNT_FAILURE",
}